module.exports = __webpack_public_path__ + "static/media/bj_bg.9fd9dd8d.png";